export const ADD_FUNDS = 'ADD_FUNDS';
export const AUTO_FUNDS = 'AUTO_FUNDS';
